import { SVGInterface } from "../../interface";

const Attachment = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M18 14.5H6.5C4.29 14.5 2.5 12.71 2.5 10.5C2.5 8.29 4.29 6.5 6.5 6.5H19C20.38 6.5 21.5 7.62 21.5 9C21.5 10.38 20.38 11.5 19 11.5H8.5C7.95 11.5 7.5 11.05 7.5 10.5C7.5 9.95 7.95 9.5 8.5 9.5H18V8H8.5C7.12 8 6 9.12 6 10.5C6 11.88 7.12 13 8.5 13H19C21.21 13 23 11.21 23 9C23 6.79 21.21 5 19 5H6.5C3.46 5 1 7.46 1 10.5C1 13.54 3.46 16 6.5 16H18V14.5Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Attachment;
